<script setup lang="ts">
import { semanticTokensNeutralDefaultText } from '@workspace/design-tokens/tokens'

import Icon from '~/assets/images/icons/done.svg'

withDefaults(
  defineProps<{
    size: number
    fill?: string
  }>(),
  {
    fill: semanticTokensNeutralDefaultText,
  }
)
</script>

<template>
  <div class="wrapper">
    <Icon :fill="fill" :height="size" :width="size" />
  </div>
</template>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
